import { EditOutlineIcon, PetitionIcon, SpeakerIcon } from '@change/ds-icons';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { translationKey } from '@change-corgi/core/i18n';

type ProofItemDefinition = Readonly<{
	key: TranslationKey;
	Icon: typeof PetitionIcon;
}>;

/** The three cycling proof items, in the order they are shown. */
export const PROOF_ITEMS: readonly ProofItemDefinition[] = [
	{
		key: translationKey('corgi.login_or_signup.sap_cycling_proof.proof.petitions_started'),
		Icon: PetitionIcon,
	},
	{
		key: translationKey('corgi.login_or_signup.sap_cycling_proof.proof.signatures_added'),
		Icon: EditOutlineIcon,
	},
	{
		key: translationKey('corgi.login_or_signup.sap_cycling_proof.proof.decision_makers_reached'),
		Icon: SpeakerIcon,
	},
];
